// Profile routes (/profile/[username], /user-profile) + /ideas/[id].
export const profile: Record<string, string> = {
  // /profile/[username] redirect shell
  'Loading profile…': 'Učitavanje profila…',

  // /user-profile page
  'Could not load your profile. Please try signing out and back in.': 'Nije moguće učitati tvoj profil. Probaj da se odjaviš i ponovo prijaviš.',
  'This trader has set their profile to private.': 'Ovaj trejder je podesio profil kao privatan.',
  'Failed to load profile': 'Učitavanje profila nije uspelo',
  'Back to feed': 'Nazad na feed',
  'Private profile': 'Privatan profil',
  'Profile not found': 'Profil nije pronađen',
  'Back to Feed': 'Nazad na feed',
  'Could not open the conversation.': 'Nije moguće otvoriti razgovor.',
  'Message': 'Pošalji poruku',
  'to see their trades in your feed': 'da vidiš njegove trejdove u svom feedu',
  'trades': 'trejdova',
  'Live-Verified': 'Live-verifikovan',
  'Verified Score': 'Verifikovani skor',
  'Gain': 'Dobit',
  'Profit Factor': 'Profit faktor',
  'Real connected account · read-only · verified history. Beta — equity %-based.': 'Pravi povezani nalog · samo za čitanje · verifikovana istorija. Beta — na bazi % ekvitija.',
  'SIMULATED': 'SIMULIRANO',
  'Demo equity': 'Demo ekviti',
  'Balance': 'Stanje',
  'from $10k start': 'od početnih $10k',
  'Closed Positions': 'Zatvorene pozicije',
  'Demo Win Rate': 'Demo uspešnost',
  'STM Score (risk-adjusted)': 'STM skor (korigovan za rizik)',
  'Expectancy': 'Očekivanje',
  'STM Score (risk-adjusted rank) unlocks after enough settled trades.': 'STM skor (rang korigovan za rizik) otključava se posle dovoljno zatvorenih trejdova.',
  'Simulated results from a $10k demo account — not real-money performance.': 'Simulirani rezultati sa $10k demo naloga — nisu učinak sa pravim novcem.',
  'Market Focus': 'Fokus tržišta',
  'No trade data yet': 'Još nema podataka o trejdovima',

  // ProfileHeader
  'Image must be under 5MB': 'Slika mora biti manja od 5MB',
  'Use JPG, PNG, or WebP': 'Koristi JPG, PNG ili WebP',
  'Upload failed': 'Otpremanje nije uspelo',
  'Profile photo updated!': 'Profilna fotografija ažurirana!',
  'Failed to upload': 'Otpremanje nije uspelo',
  'Now following': 'Sada pratiš',
  'Unfollowed': 'Više ne pratiš',
  'Please sign in to follow traders': 'Prijavi se da bi pratio trejdere',
  'Failed to update follow status': 'Ažuriranje praćenja nije uspelo',
  'Network error — please try again': 'Greška mreže — pokušaj ponovo',
  'Profile link copied': 'Link profila kopiran',
  '15+ closed trades with a minimum 55% win rate': '15+ zatvorenih trejdova sa minimalno 55% uspešnosti',
  '5–14 closed trades': '5–14 zatvorenih trejdova',
  '1–4 closed trades': '1–4 zatvorena trejda',
  'Elite': 'Elita',
  'Rising': 'U usponu',
  'Change profile photo': 'Promeni profilnu fotografiju',
  'Edit Profile': 'Izmeni profil',
  'Share profile': 'Podeli profil',
  'More options': 'Više opcija',
  '⛓️ Live-verified (on-chain)': '⛓️ Live-verifikovan (on-chain)',
  'Verified trustlessly from on-chain (Hyperliquid) history': 'Verifikovano bez posrednika iz on-chain (Hyperliquid) istorije',
  'Verified from a real connected account (beta)': 'Verifikovano sa pravog povezanog naloga (beta)',
  'Statement-verified': 'Verifikovan izvodom',
  'Statement reviewed and verified by our team': 'Izvod pregledan i verifikovan od strane našeg tima',
  'Verified Trader': 'Verifikovani trejder',
  'Founding Member': 'Founding Member',
  'One of the first 100 traders to post here': 'Jedan od prvih 100 trejdera koji su ovde nešto objavili',
  'Markets:': 'Tržišta:',
  'POSTED-IDEA SCORE': 'SKOR OBJAVLJENIH IDEJA',
  '(legacy)': '(staro)',
  'Avg RR:': 'Prosečan RR:',
  'Consistency:': 'Doslednost:',
  'Trader Level': 'Nivo trejdera',
  '-day streak': '-dnevni niz',
  'Idea Win Rate': 'Uspešnost ideja',
  'Posted Ideas': 'Objavljene ideje',
  'Idea Avg R:R': 'Prosečan R:R ideja',
  'Friends': 'Prijatelji',
  'Likes': 'Lajkovi',
  'Wins': 'Pobede',
  'Losses': 'Porazi',
  'Break Even': 'Nula (BE)',
  'Closed': 'Zatvoreno',
  'Battle Record': 'Rezultat bitki',

  // ProfileTabs
  'Liked': 'Lajkovano',
  'Achievements': 'Dostignuća',
  'Social': 'Društveno',
  'About': 'O trejderu',
  'Analyses': 'Analize',
  'Open': 'Otvoreno',
  'Won': 'Dobijeno',
  'Lost': 'Izgubljeno',
  'Grid view': 'Prikaz mreže',
  'List view': 'Prikaz liste',
  'No analyses yet': 'Još nema analiza',
  'No signals yet': 'Još nema signala',
  'No matching signals yet': 'Nema signala u ovom filteru',
  'Load more': 'Učitaj još',
  'Ideas liked by': 'Ideje koje je lajkovao',
  'No liked trades yet': 'Još nema lajkovanih trejdova',
  'No followers yet': 'Još nema pratilaca',
  'Not following anyone yet': 'Još ne prati nikoga',
  'Battles Won': 'Dobijene bitke',
  'Battles Lost': 'Izgubljene bitke',
  'Battle Win Rate': 'Uspešnost u bitkama',
  'No battles yet': 'Još nema bitki',
  'Battles are created automatically when opposing trades are posted': 'Bitke se prave automatski kada se objave suprotni trejdovi',
  '🏆 Battle Champion': '🏆 Šampion bitki',
  '⚔ Battle Competitor': '⚔ Takmičar u bitkama',
  'View all battles →': 'Prikaži sve bitke →',
  'Unlocked': 'Otključano',
  'Locked': 'Zaključano',
  'Posted-Idea Score': 'Skor objavljenih ideja',
  'LEGACY': 'STARO',
  'From your public posted ideas. Your simulated account performance is shown on the Performance card.': 'Iz tvojih javno objavljenih ideja. Učinak simuliranog naloga je prikazan na kartici Učinak.',
  'Overall Score': 'Ukupan skor',
  'Consistency': 'Doslednost',
  'Accuracy': 'Preciznost',
  'Posted-Idea Stats': 'Statistika objavljenih ideja',
  'Closed Ideas': 'Zatvorene ideje',
  'Open Ideas': 'Otvorene ideje',
  'Likes Received': 'Primljeni lajkovi',

  // ProfilePerformanceChart
  'Trade Outcomes': 'Ishodi trejdova',
  'total trades': 'ukupno trejdova',
  'No trades yet': 'Još nema trejdova',
  'Win rate across closed trades': 'Uspešnost zatvorenih trejdova',
  'Activity (Last 16 Weeks)': 'Aktivnost (poslednjih 16 nedelja)',
  'Ideas posted per week': 'Objavljenih ideja nedeljno',
  'Ideas': 'Ideje',
  'No activity yet': 'Još nema aktivnosti',

  // /ideas/[id]
  'Trade idea not found': 'Trejd ideja nije pronađena',
  'Failed to load trade idea': 'Učitavanje trejd ideje nije uspelo',
  'Loading idea…': 'Učitavanje ideje…',
  'Idea Not Found': 'Ideja nije pronađena',
  'This trade idea does not exist or has been removed.': 'Ova trejd ideja ne postoji ili je uklonjena.',
  'R:R Breakdown': 'R:R pregled',
  'Risk': 'Rizik',
  'Reward': 'Nagrada',
  'Best R:R': 'Najbolji R:R',
  'Price Levels': 'Cenovni nivoi',
  'Entry / Exit Signals': 'Signali ulaska / izlaska',
  'Entry Zone': 'Zona ulaska',
  'Invalidation': 'Invalidacija',
  'Target 1': 'Cilj 1',
  'Target 2': 'Cilj 2',
  'Target 3': 'Cilj 3',
  'Discussion': 'Diskusija',
  'Add your analysis…': 'Dodaj svoju analizu…',
  'Posting…': 'Objavljivanje…',
  'Post': 'Objavi',
  'Comment posted': 'Komentar objavljen',
  'Failed to post comment': 'Objavljivanje komentara nije uspelo',
  'No comments yet. Be the first to share your analysis.': 'Još nema komentara. Budi prvi koji će podeliti analizu.',
  'Feed': 'Feed',
  'Live trading': 'Trejding uživo',
  'Chart': 'Grafikon',
  'Setup Description / Thesis': 'Opis setapa / teza',
  'edited': 'izmenjeno',
  'No commentary yet — click Edit to add your thesis.': 'Još nema komentara — klikni Izmeni da dodaš svoju tezu.',
  'Trade Details': 'Detalji trejda',
  "Locked — verified entry, can't be changed": 'Zaključano — verifikovan unos, ne može se menjati',
  'Instrument': 'Instrument',
  'Direction': 'Smer',
  'Market': 'Tržište',
  'Timeframe': 'Vremenski okvir',
  'Send this idea via direct message': 'Pošalji ovu ideju u direktnoj poruci',
  'Uvod attendee': 'Polaznik Uvoda',
  'Attended the FX Doctor Uvod presentation': 'Bio na FX Doctor Uvod prezentaciji',
};
